import { render, staticRenderFns } from "./IncomeImport.vue?vue&type=template&id=2132b85c&scoped=true"
import script from "./IncomeImport.vue?vue&type=script&lang=ts"
export * from "./IncomeImport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2132b85c",
  null
  
)

export default component.exports